export const HELFEN_SEARCH_BASE_YEAR = 2021

/**
 * Estimate average searches per year since 2021, rounded up to the next 100.
 */
export function helfenSearchesPerYear (total, now = new Date()) {
  const count = Number(total) || 0
  if (count <= 0) return 0

  const years = Math.max(1, now.getFullYear() - HELFEN_SEARCH_BASE_YEAR)
  const perYear = count / years
  return Math.ceil(perYear / 100) * 100
}
